
import Vue from "vue";
import {
  getHygienistCancelled,
  updateHygienistCancelled,
  moveTwoPF,
  updateTable
} from "@/api";
import { currentTimeZone } from "@/helpers";
import { format, utcToZonedTime } from "date-fns-tz";
import { mapActions } from "vuex";
import { JobInterface } from "./interfaces";
import TempStarsTableTitle from "@/components/shared/TempStarsTableTitle";

export default Vue.extend({
  name: "SNCbyHygDa",
  components: {
    TempStarsTableTitle
  },
  data() {
    return {
      cancels: [] as any,
      cancelsId: null,
      dialog: false,
      currentJob: {} as JobInterface,
      note: "",
      alert: false,
      alertMessage: ""
    };
  },
  methods: {
    ...mapActions(["addAdminLogging"]),
    clickTwoPF(job: JobInterface): void {
      this.dialog = true;
      this.currentJob = job;
      this.note = "";
    },
    async doneSNC(id: number) {
      try {
        await updateHygienistCancelled({
          id,
          ifDone: true
        });
        this.alertMessage = "Success";
        this.alert = true;
        await this.getSNC();
      } catch (error) {
        console.error("Error marking SNC as done:", error);
        this.alertMessage =
          error instanceof Error
            ? `Error: ${error.message}`
            : "Error marking as done. Please, try again.";
        this.alert = true;
      } finally {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      }
    },
    async giveTwoPF() {
      const noteText =
        this.note && this.note.trim() ? ` note: ${this.note.trim()}` : "";
      const notes = `${format(
        new Date(),
        "MMMM do yyyy, HH:mm"
      )} (1PF button)${noteText}`;

      try {
        const userString = localStorage.getItem("user") || "";
        const agent = userString.startsWith("{")
          ? JSON.parse(userString)
          : userString;

        const res = await moveTwoPF({
          locationId: this.currentJob.locationId,
          practiceName: this.currentJob.practiceName as string,
          agent: agent,
          email: this.currentJob.email,
          note: notes
        });

        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        await updateTable({
          tablename: "Job",
          columnname: "pfGiven",
          id: this.currentJob.jobId,
          value: 1,
          prevValue: 0
        });

        await this.addLogging(this.currentJob);

        this.alertMessage = "Success - Free placement granted and note added";
        this.alert = true;
        this.dialog = false;
        this.note = "";
        await this.getSNC();
      } catch (error) {
        console.error("Error giving free placement:", error);
        this.alertMessage =
          error instanceof Error
            ? `Error: ${error.message}`
            : "Error. Please, try again.";
        this.alert = true;
        this.dialog = false;
      } finally {
        setTimeout(() => {
          this.alert = false;
        }, 3000);
      }
    },
    async getSNC() {
      const data = await getHygienistCancelled();
      this.cancels = data
        .map(job => {
          job.postedStart = format(
            utcToZonedTime(job.postedStart, currentTimeZone()),
            "MMMM do yyyy, HH:mm"
          );
          job.postedEnd = format(
            utcToZonedTime(job.postedEnd, currentTimeZone()),
            "MMMM do yyyy, HH:mm"
          );
          job.cancelTimestamp = format(
            utcToZonedTime(job.cancelTimestamp, currentTimeZone()),
            "MMMM do yyyy, HH:mm"
          );
          return job;
        })
        .sort((a, b) => a.ifDone - b.ifDone);
    },
    async addLogging(job: any): Promise<void> {
      await this.addAdminLogging({
        adminId: parseInt(localStorage.getItem("adminId")!),
        buttonUsed: "Give 1 PF",
        hygienistId: job.hygienistId,
        firstName: job.firstName,
        lastName: job.lastName,
        locationId: job.locationId,
        practiceName: job.practiceName,
        email: job.email
      });
    }
  },
  created() {
    this.getSNC();
  }
});
